'use strict';
import {ListCtrl} from '../lmtdb/listctrl.js';
import {konkursasModel} from '../../models/konkursasmodel.js';

export class KonkursaiListSiteCtrl extends ListCtrl {
    storageNames = {query: 'KonkursaiListSiteQuery'};

    constructor($scope, $http, $filter, $timeout, $locale, jsDataService) {
        const g = (typeof window !== 'undefined') ? window : {};
        jsDataService.data.cfgAppName = g.cfgAppName || jsDataService.data.cfgAppName || '';
        jsDataService.data.cfgDataUrl = g.cfgDataUrl || jsDataService.data.cfgDataUrl || 'listdata';
        jsDataService.data.cfgExportUrl = g.cfgExportUrl || jsDataService.data.cfgExportUrl || '';
        jsDataService.data.cfgQueryStorageKey = g.cfgQueryStorageKey || jsDataService.data.cfgQueryStorageKey || 'KonkursaiListSiteQuery';
        jsDataService.data.cfgQuery = g.cfgQuery || jsDataService.data.cfgQuery || {};
        if (g.cfgClassif) jsDataService.data.cfgClassif = g.cfgClassif;

        if (g.cfgDisplayColumns) jsDataService.data.cfgDisplayColumns = g.cfgDisplayColumns;
        if (g.cfgFooterColumns) jsDataService.data.cfgFooterColumns = g.cfgFooterColumns;

        const q = jsDataService.data.cfgQuery || {};
        if (!q.filters) q.filters = {};

        if (!q.filters.institucija) q.filters.institucija = {field:'institucija', title:'Institucija', isChip:true, value:null};
        if (!q.filters.mkryptis)    q.filters.mkryptis    = {field:'mkryptis',    title:'Mokslo, meno kryptys', isChip:true, value:null};
        if (!q.filters.status)      q.filters.status      = {field:'status',      title:'Statusas',       isChip:true, value:null, type:'text'};

        q.filters.institucija.type = 'classif';
        q.filters.institucija.classifName = 'institucijos';
        q.filters.mkryptis.type = 'classif';
        q.filters.mkryptis.classifName = 'kryptys';

        if (q.filters.institucija.value === 0) q.filters.institucija.value = null;
        if (q.filters.mkryptis.value === 0) q.filters.mkryptis.value = null;

        jsDataService.data.cfgQuery = q;

        super($scope, $http, $filter, $timeout, $locale, jsDataService);

        this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');

        const key = this.jsDataService.get('cfgQueryStorageKey', '');
        if (key) this.storageNames.query = key;

        this.classif = this.jsDataService.get('cfgClassif', {active:[], institucijos:[], kryptys:[]});
    }

    $onInit() {
        super.$onInit();

        const urlParams = new URLSearchParams(window.location.search);
        const instFromUrl = urlParams.get('institucija');
        const statusFromUrl = urlParams.get('status');

        if (instFromUrl || statusFromUrl) {
            if (instFromUrl) {
                const instValue = parseInt(instFromUrl, 10);
                if (instValue > 0) {
                    this.query.filters.institucija.value = instValue;
                }
            }

            if (statusFromUrl) {
                this.query.filters.status.value = statusFromUrl;
            }
        }
    }

    setData(data) {
        this.data = [];
        for (let ln of data) this.data.push(new konkursasModel(ln, this.$filter, this.jsDataService));
    }

    getColValue(row, col) {
        if (typeof row[col] === 'undefined') return '';
        if (row instanceof konkursasModel) return row.getValue(col);
        return row[col];
    }

    getFooterData(col) {
        if (this.columnsData && this.columnsData.footer && typeof this.columnsData.footer[col] !== 'undefined') {
            return this.columnsData.footer[col].value;
        }
        return '';
    }
}